<template>
  <el-table-column :label="label" :prop="prop" class-name="aircraft-type" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '機体区分'
    },
    prop: {
      type: String,
      default: 'aircraft_type'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.aircraft-type {
      width: 8em;
    }
  }
}
</style>
